import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';
import { useApplicationContext } from '../../ApplicationContext';
import { EStepCodes } from '../../../types/requestForm';
import { sendFeedback } from '../../../actions/sendFeedback';
import { createOfferComplaint } from '../../../actions/createOfferComplaint';
import { getModerationIssues } from '../../../actions/moderationIssues';
import { EOwnerComplaintType } from '../../../types/ownerComplaintType';
import { selectFormKey } from '../../../selectors/formKey';
import { selectFormInitialState } from '../../../selectors/formInitialState';
export function useFormContainer() {
  var _ref, _ref3;
  var formInitialState = useSelector(selectFormInitialState);
  var formKey = useSelector(selectFormKey);
  var dispatch = useDispatch();
  var context = useApplicationContext();
  var logger = context.logger;
  var handleSubmit = React.useCallback(function (_x) {
    return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formData) {
      var formValue, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            formValue = formData.formValue;
            _context.next = 3;
            return dispatch(sendFeedback({
              formValue: formValue
            }));
          case 3:
            result = _context.sent;
            if (!(result.status !== 'succeed')) {
              _context.next = 6;
              break;
            }
            throw result.errorMessage;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))).apply(this, arguments);
  }, [dispatch]);
  var handleNextStep = React.useCallback(function (_x2) {
    return (_ref3 = _ref3 || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var formValue, fromStep;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            formValue = _ref2.formValue, fromStep = _ref2.fromStep;
            if (!(fromStep.code === EStepCodes.OfferComplaintInitial && formValue.ownerComplaintType === EOwnerComplaintType.CreateComplaint)) {
              _context2.next = 5;
              break;
            }
            _context2.next = 4;
            return dispatch(createOfferComplaint(formValue));
          case 4:
            return _context2.abrupt("return", Promise.reject());
          case 5:
            if (!(fromStep.code === EStepCodes.ModerationInitial)) {
              _context2.next = 8;
              break;
            }
            _context2.next = 8;
            return dispatch(getModerationIssues(formValue));
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))).apply(this, arguments);
  }, [dispatch]);
  var handleCrackedNextStepCondition = React.useCallback(function (step, error) {
    logger.error(error, {
      stepCode: step.code,
      domain: 'frontend-feedback-form-widget.FormContainer.handleCrackedNextStepCondition'
    });
  }, [logger]);
  return {
    formKey: formKey,
    formInitialState: formInitialState,
    handleSubmit: handleSubmit,
    handleNextStep: handleNextStep,
    handleCrackedNextStepCondition: handleCrackedNextStepCondition
  };
}